import { type EventObject, type MachineContext } from 'xstate';

/**
 * Structural equivalent of xstate 5's `GuardArgs`, which is not exported from
 * the package root (only the built-in guard functions are public).
 */
export type GuardArgs<TContext extends MachineContext, TExpressionEvent extends EventObject> = {
  context: TContext;
  event: TExpressionEvent;
};
